import React, { useState } from 'react';
import { usePathname, useRouter } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';
import { isDarkTheme } from '@/constants/Colors';
import { useBusinessWorkspace, workspacePath, businessHistoryPath, businessWorkPath } from './BusinessWorkspaceContext';
import { useBusinessList } from './useBusinessResource';
import { useNewBusinessChat } from './useNewBusinessChat';
import './businessChat.css';

export function businessTheme(colors, theme) {
  return { colorScheme: isDarkTheme(theme) ? 'dark' : 'light', '--gb-chat-bg': colors.solid_color_primary, '--gb-chat-panel': colors.solid_color_secondary,
    '--gb-chat-text': colors.text_color_primary, '--gb-chat-muted': colors.text_color_secondary,
    '--gb-chat-border': colors.border_color_secondary };
}
export function WorkspaceSelect() {
  const context = useBusinessWorkspace(), router = useRouter();
  return <label className="gb-chat-workspace">Workspace
    <select aria-label="Workspace" value={context.workspaceId || ''} onChange={event => router.push(event.target.value ? workspacePath(event.target.value) : '/app')}>
      <option value="">Personal</option>
      {!context.workspace && context.workspaceId && <option value={context.workspaceId}>Business</option>}
      {context.workspaces.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
    </select>
  </label>;
}
export function NewBusinessChat({ children = 'New chat' }) {
  const { create, busy, error } = useNewBusinessChat();
  return <><button type="button" onClick={create} disabled={busy}>{busy ? 'Creating…' : children}</button>{error && <p role="alert">{error}</p>}</>;
}
function Navigation({ compact }) {
  const context = useBusinessWorkspace(), pathname = usePathname(), router = useRouter();
  const [search, setSearch] = useState(''), [filter, setFilter] = useState(''), [archived, setArchived] = useState(false);
  const history = useBusinessList((after, options) => context.api.chats(context.workspaceId, { after, search: filter, archived }, {
    isRequestCurrent: () => options.isRequestCurrent() && context.current(),
  }), [context.accountId, context.workspaceId, context.revision, filter, archived]);
  return <>
    <WorkspaceSelect />
    <NewBusinessChat />
    <button type="button" onClick={() => router.push(businessWorkPath(context.workspaceId))}>New task</button>
    {!compact && <><form onSubmit={event => { event.preventDefault(); setFilter(search); }} className="gb-chat-search">
      <input aria-label="Search company chats" placeholder="Search chats" maxLength={200} value={search} onChange={event => setSearch(event.target.value)} />
      <button type="submit">Search</button>
    </form>
    <label className="gb-chat-archive"><input type="checkbox" checked={archived} onChange={event => setArchived(event.target.checked)} /> Archived chats</label>
    <nav aria-label="Company chats" className="gb-chat-history">
      {history.items.map(chat => <button key={chat.id} type="button" aria-current={pathname === businessHistoryPath(context.workspaceId, chat) ? 'page' : undefined}
        onClick={() => router.push(businessHistoryPath(context.workspaceId, chat))}>{chat.title || 'New chat'}</button>)}
      {history.loading && <p role="status">Loading chats…</p>}
      {!history.loading && !history.items.length && !history.error && <p>No chats yet.</p>}
      {history.error && <p role="alert">{history.error.message} <button type="button" onClick={history.refresh}>Retry</button></p>}
      {history.next && <button type="button" disabled={history.loading} onClick={history.more}>Load more</button>}
    </nav></>}
    <a className="gb-chat-settings" href={`/settings?tab=business&workspace=${encodeURIComponent(context.workspaceId)}`}>Business settings</a>
  </>;
}
export default function BusinessNavigation({ compact = false }) {
  const context = useBusinessWorkspace(), { colors, theme } = useTheme();
  if (!context?.workspaceId) return null;
  return <aside className={`gb-chat-navigation${compact ? ' gb-chat-navigation-compact' : ''}`} style={businessTheme(colors, theme)}>
    <Navigation key={`${context.accountId}:${context.workspaceId}`} compact={compact} />
  </aside>;
}
